import React, { useEffect, useState } from "react";
import { api } from "../lib/api";
import Panel from "../components/Panel";
import KpiCard from "../components/KpiCard";
import { fmtDate } from "../lib/format";

const STATUS_COLOR = { "Filed": "#4af6c3", "Pending": "#fb8b1e", "Upcoming": "#8892B0", "In Progress": "#fb8b1e", "Action Required": "#ff433d" };

export default function Compliance() {
    const [data, setData] = useState(null);
    useEffect(() => { api.get("/compliance").then((r) => setData(r.data)); }, []);
    if (!data) return <div className="font-mono-fin text-sm text-[var(--text-secondary)]">// LOADING COMPLIANCE...</div>;

    return (
        <div className="space-y-4">
            <div>
                <div className="font-mono-fin text-[10px] uppercase tracking-[0.25em] text-[var(--brand-amber)] mb-1">// STATUTORY COMPLIANCE</div>
                <h1 className="font-display font-black text-3xl">Compliance Calendar</h1>
            </div>

            <div className="grid grid-cols-2 md:grid-cols-4 gap-3">
                <KpiCard testId="cmp-total" label="Total Items" value={data.summary.total} format="custom" accent />
                <KpiCard testId="cmp-filed" label="Filed" value={data.summary.by_status.Filed || 0} format="custom" sub="On time" />
                <KpiCard testId="cmp-pending" label="Pending" value={data.summary.by_status.Pending || 0} format="custom" sub="Action needed" />
                <KpiCard testId="cmp-risk" label="High Risk" value={data.summary.high_risk} format="custom" sub="Escalate" />
            </div>

            <Panel testId="cmp-items" title="Compliance Register">
                <div className="overflow-x-auto">
                    <table className="w-full font-mono-fin text-xs">
                        <thead className="border-b border-panel">
                            <tr className="text-[10px] uppercase tracking-wider text-[var(--text-secondary)]">
                                <th className="text-left py-2">Category</th>
                                <th className="text-left">Description</th>
                                <th className="text-right">Due Date</th>
                                <th className="text-left">Status</th>
                                <th className="text-left">Risk</th>
                            </tr>
                        </thead>
                        <tbody>
                            {data.items.map((c) => (
                                <tr key={c.id} className="border-b border-[var(--border)]/50 hover:bg-[var(--bg-panel-hover)]">
                                    <td className="py-2"><span className="text-[10px] uppercase tracking-wider px-1.5 py-0.5 border border-panel">{c.type}</span></td>
                                    <td className="text-[var(--text-primary)]">{c.description}</td>
                                    <td className="text-right text-[var(--text-secondary)]">{fmtDate(c.due)}</td>
                                    <td><span className="text-[10px] uppercase tracking-wider px-1.5 py-0.5 border" style={{ borderColor: STATUS_COLOR[c.status] || "#E2E8F0", color: STATUS_COLOR[c.status] || "#8892B0" }}>{c.status}</span></td>
                                    <td>
                                        <span className={`text-[10px] uppercase tracking-wider ${c.risk === "High" ? "text-neg" : c.risk === "Medium" ? "text-amber" : "text-pos"}`}>{c.risk}</span>
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            </Panel>
        </div>
    );
}
